import { render, staticRenderFns } from "./NewTreeviewItem.vue?vue&type=template&id=321d4c26&scoped=true"
import script from "./NewTreeviewItem.vue?vue&type=script&lang=js"
export * from "./NewTreeviewItem.vue?vue&type=script&lang=js"
import style0 from "./NewTreeviewItem.vue?vue&type=style&index=0&id=321d4c26&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "321d4c26",
  null
  
)

export default component.exports